import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MetaTags from "react-meta-tags";
import { Col, Row, Select, Skeleton, Table } from "antd";
import PropTypes from "prop-types";
import { DownloadOutlined, PrinterFilled } from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { isEmpty } from "lodash";
import moment from "moment";
import "./index.css";
import { loadItems } from "../../store/items/actions";
import { itemHeaders } from "./data";

const ItemWiseReport = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  // const [downloadLoading, setDownloadLoading] = useState(false);

  const itemListId = {
    organizationId: props.organizationId,
    partyId: props.partyId,
  };

  //api loader
  useEffect(() => {
    dispatch(loadItems(itemListId));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { items_list = [] } = useSelector((state) => state.Items);

  const tableData =
    items_list && items_list.length > 0
      ? items_list.map((data, index) => {
          const categoryName =
            props.categoryOptions && props.categoryOptions.length > 0
              ? props.categoryOptions.find(
                  (category) => category.value === data.categoryId
                )
              : "";

          const categoryNameValue = !isEmpty(categoryName)
            ? categoryName.label
            : "";

          return {
            index: index + 1,
            itemName: data.itemName,
            _id: data._id,
            itemCode: data.itemCode,
            salesPrice: data.salesPrice,
            purchasePrice: data.purchasePrice,
            stockQTY: data.noofStock,
            batchDetails: data.batchDetails,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            customFields: data.customFields,
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            categoryNameValue: categoryNameValue,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            serialMeasuringId: data.serialMeasuringId,
            serialMeasuringName: data.serialMeasuringName,
            image: data.image,
            itemNameValue: data.itemName,
            itemCodeValue: data.itemCode,
            salesPriceValue: data.salesPrice,
            purchasePriceValue: data.purchasePrice,
            stockQTYValue: data.noofStock,
            categoryIdValue: data.categoryId,
            descriptionValue: data.description,
            // categoryNameValue: data.categoryName,
            isProduct: data.isProduct,
            isService: data.isService,
            measuringId: data.measuringId,
            description: data.description,
            serialDetails: data.serialDetails,
            // serialMeasuringId: data.serialMeasuringId,
            updatedAt: data.updatedAt,

            status: data.status,
          };
        })
      : [];

  const [selectDays, setSelectDays] = useState([]);

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = () => {
    // setDownloadLoading(true);

    const tableExportData =
      items_list && items_list.length > 0
        ? items_list.map((data, index) => {
            return {
              index: index + 1,
              quantity: data.Quantity,
              closingStock: data.closingStock,
              date: data.createdAt
                ? moment(data.createdAt).format("DD-MM-YYYY")
                : "-",
              itemId: data.itemId,
              organizationId: data.organizationId,
              serialIds: data.serialIds,
              invoiceNumber: data.invoiceNumber ? data.invoiceNumber : "--",
              transactionType: data.transactionType,
              updatedAt: data.updatedAt
                ? moment(data.updatedAt).format("DD-MM-YYYY")
                : "-",
              _id: data._id,
            };
          })
        : [];
    setTimeout(() => {
      let headerData = [
        "Date, Transaction Type, Quantity, Invoice Number, Closing Stock",
      ];

      let usersCsv = !isEmpty(tableExportData)
        ? tableExportData.reduce((acc, user) => {
            const {
              date,
              transactionType,
              quantity,
              invoiceNumber,
              closingStock,
            } = user;
            acc.push([
              date,
              transactionType,
              quantity,
              invoiceNumber,
              closingStock,
            ]);

            console.log("test", acc);
            return acc;
          }, [])
        : false;
      console.log(usersCsv, "usersCsv");

      const usersList =
        !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

      downloadFile({
        data: [...headerData, ...usersList].join("\n"),
        fileName: "ItemReports.csv",
        fileType: "text/csv",
      });
      // setDownloadLoading(false);
    }, 2500);
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Parties | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={8} className="mr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth: "150%",
                    marginRight: "10px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  suffixIcon={<BiCalendar size={16} />}
                  placeholder="Select Days"
                  value={selectDays}
                  onChange={(e) => setSelectDays(e)}
                  className="h-[40px] w-[100%]"
                />
              )}
            </Col>

            <Col span={4} className="pr-3 cursor-pointer">
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth: "100px",
                    marginRight: "10px",
                  }}
                ></Skeleton.Input>
              ) : (
                <div
                  onClick={() => exportToCsv()}
                  className="flex border p-2 rounded-md border-1 text-center"
                >
                  <DownloadOutlined className="text-[16px] mr-3" /> Download
                </div>
              )}
            </Col>
            <Col span={4} className="pr-3 cursor-pointer">
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth: "100px",
                    marginRight: "10px",
                  }}
                ></Skeleton.Input>
              ) : (
                <div className="flex border p-2 rounded-md  border-1 text-center">
                  <PrinterFilled className="text-[16px] mr-3" /> Print
                </div>
              )}
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mt-4">
          <div>
            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={itemHeaders}
              dataSource={tableData}
              sortDirections={"ascend"}
              loading={loading ? true : false}
              showSorterTooltip={"sorter-icon"}
              // onRow={partiesRoutes}
              // rowHoverable={partiesRoutes}
              // sticky=""

              // rowSelection={{
              //   type: selectionType,
              //   ...rowSelection,
              // }}
              // rowSelection={true}
              // rowSelection={partiesRoutes}
              scroll={{ y: 210 }}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

ItemWiseReport.propTypes = {
  location: PropTypes.any,
  partyId: PropTypes.any,
  categoryOptions: PropTypes.any,
  organizationId: PropTypes.any,
};

export default ItemWiseReport;
